<div class="sk-three-bounce" *ngIf="isBouncing">
    <div class="sk-child sk-bounce1" [style.background-color]="color"></div>
    <div class="sk-child sk-bounce2" [style.background-color]="color"></div>
    <div class="sk-child sk-bounce3" [style.background-color]="color"></div>
</div>